import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable()
export class NotificationService {
    constructor(private messageService: MessageService) {

    }

    public addErrorMessage(title: string, message: string) {
        this.messageService.add({severity: 'error', summary: title, detail: message, life: 10000, sticky: false});
    }

    public addInfoMessage(title: string, message: string) {
        this.messageService.add({severity: 'info', summary: title, detail: message, life: 10000, sticky: false});
    }

    public addWarnMessage(title: string, message: string) {
        this.messageService.add({severity: 'warn', summary: title, detail: message, life: 10000, sticky: false});
    }

    public addSuccessMessage(title: string, message: string) {
        this.messageService.add({severity: 'success', summary: title, detail: message, life: 10000, sticky: false});
    }
}
